import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import TourAddOnsTable from './tables/add-ons-table';
import TourGuestTable from './tables/guest-table';
import TourParticipantDetailTable from './tables/participant-detail-table';

export default function TourCard() {
  const { t } = useTranslation();
  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <Text variant="HeadingXSmall">{t('common:tour_participant')}</Text>
      <Separator gap={16} />
      <TourGuestTable />
      <Separator gap={32} />
      <HOCInput keys={['approvalable']}>
        {(value) =>
          (value.approvalable.tourSales || []).map((item, idx) => (
            <React.Fragment key={item.id}>
              <Text variant="LabelMedium">
                {item.tourSaleGuests[idx].guestName}
              </Text>
              <Separator gap={16} />
              <TourParticipantDetailTable parentIndex={idx} />
              <Separator gap={16} />
            </React.Fragment>
          ))
        }
      </HOCInput>

      <TourAddOnsTable />
    </CardSection>
  );
}
